import React from 'react';
import styled from 'styled-components';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2;
var Wrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 10px;\n\tborder: solid 1px #d8d8d8;\n\tborder-radius: 6px;\n\tfont-size: 14px;\n\tbox-shadow: 0px 1px 4px 0px #00000026;\n\twidth: 100%;\n\t", "\n"])), function (props) {
  return "" + (props == null ? void 0 : props.customStyle);
});
var Input = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tborder: none;\n\toutline: none;\n\twidth: calc(100% - 20px);\n\tbackground: transparent;\n\tmargin-left: 10px;\n"])));

var InputField = function InputField(_ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      fullView = _ref.fullView,
      inputName = _ref.inputName,
      inputDisabled = _ref.inputDisabled,
      inputWrapStyle = _ref.inputWrapStyle,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Wrap, {
    customStyle: inputWrapStyle
  }, fullView && children, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    placeholder: placeholder,
    value: value,
    onChange: function onChange(e) {
      return _onChange == null ? void 0 : _onChange(e.target.value);
    },
    fullView: fullView,
    name: inputName,
    disabled: inputDisabled
  }));
};

InputField.defaultProps = {
  inputName: '',
  inputDisabled: false,
  onChange: undefined,
  value: undefined,
  inputWrapStyle: undefined,
  children: undefined
};

export { InputField as I, _taggedTemplateLiteralLoose as _ };
